import React from 'react';
import { reportReadEntity } from './reportTimeSystem.api';

type Props = {
  readKey: string;
  entityType: 'lawyer' | 'lawFirm' | 'enterprise' | 'law' | 'jurisdiction';
  children: React.ReactNode;
};

export class ReportTimeSystemEntity extends React.Component<Props> {
  REPORT_INTERVAL = 5000;

  INACTIVITY_DELAY = 20000;

  active = false;

  lastActivityStartedAt = 0;

  lastActivity = 0;

  lastReportedReadTime = 0;

  readTime = 0;

  interval: number = 0;

  timeout: number = 0;

  componentDidMount() {
    this.interval = window.setInterval(
      this.rtsReportRead,
      this.REPORT_INTERVAL,
    );
    window.addEventListener('focus', this.rtsActivity);
    window.addEventListener('scroll', this.rtsActivity);
    window.addEventListener('blur', this.rtsStopActivity);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    window.removeEventListener('focus', this.rtsActivity);
    window.removeEventListener('scroll', this.rtsActivity);
    window.removeEventListener('blur', this.rtsStopActivity);
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  rtsActivity = () => {
    if (!this.active) {
      this.active = true;
      this.lastActivityStartedAt = new Date().getTime();
    }
    this.lastActivity = new Date().getTime();
    const lastTime = { start: this.lastActivity };
    this.timeout = window.setTimeout(() => {
      if (this.lastActivity === lastTime.start) {
        this.rtsStopActivity();
      }
    }, this.INACTIVITY_DELAY);
  };

  rtsStopActivity = () => {
    if (this.active) {
      this.active = false;
      this.readTime =
        this.readTime + new Date().getTime() - this.lastActivityStartedAt;
      this.lastActivityStartedAt = 0;
    }
  };

  rtsGetReadTime = () => {
    let total = this.readTime;
    if (this.active) {
      const now = new Date().getTime();
      total += now - this.lastActivityStartedAt;
    }
    const readTime = total / 1000;
    return readTime;
  };

  rtsReportRead = async () => {
    const readTime = this.rtsGetReadTime();
    if (
      (!this.lastReportedReadTime || this.lastReportedReadTime < readTime) &&
      !document.hidden
    ) {
      this.lastReportedReadTime = readTime;
      try {
        await reportReadEntity({
          key: this.props.readKey,
          readTime,
          entityType: this.props.entityType,
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('Error in AJAX call of rtsReportRead');
        throw error;
      }
    }
  };

  render() {
    return <div onMouseMove={this.rtsActivity}>{this.props.children}</div>;
  }
}
